import type { Question } from '@/engine';

interface Props {
  question: Question;
  /** chosen index during feedback, null while answering */
  picked: number | null;
  onPick: (i: number) => void;
  /** reviewing a past question: nothing can be picked */
  readOnly?: boolean;
}

export function AnswerGrid({ question, picked, onPick, readOnly = false }: Props) {
  const stateOf = (i: number): 'ok' | 'bad' | 'dim' | undefined => {
    if (picked === null) return undefined;
    if (i === question.correct) return 'ok';
    if (i === picked) return 'bad';
    return 'dim';
  };
  return (
    <div className="grid w-full max-w-[840px] grid-cols-2 gap-4 max-sm:grid-cols-1">
      {question.options.map((o, i) => (
        <button
          key={`${o}-${i}`}
          type="button"
          className="ans num enter"
          style={{ animationDelay: `${i * 40}ms` }}
          data-state={stateOf(i)}
          disabled={readOnly || picked !== null}
          onClick={() => onPick(i)}
        >
          <span className="absolute top-3 left-4 font-mono text-[12px] font-bold text-accent">[{i + 1}]</span>
          {o}
        </button>
      ))}
    </div>
  );
}
